import { makeStyles } from "@fluentui/react-components";

export const colors = {
  primaryButtonBackground: "#FFFFFF",
  primaryBackground: "#FFFFFF",
  fundwave: "#3D74AD",
  hyperlink: "#3D74AD",
  secondaryText: "#666",
  borderColor: "#E0E0E0",
  errorColor: "#d50000",
  boxShadow: "rgba(0, 0, 0, 0.1)",
  // Notification colors
  warningBackground: "#FEEEBC",
  warningText: "#C18E35",
  warningBorder: "#D7B25C",
  warningButtonBackground: "#C18E35",
  warningButtonText: "#FEEEBC"
};

export const centered = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};

export const card = {
  ...centered,
  backgroundColor: colors.primaryButtonBackground,
  width: "100%",
  padding: "10px",
  overflow: "hidden",
  border: `1px solid ${colors.borderColor}`,
  borderRadius: "8px",
  boxShadow: `0 2px 8px ${colors.boxShadow}`
};

export const useTextStyles = makeStyles({
  heading1: {
    fontWeight: 600,
    fontSize: "16px"
  },
  heading2: {
    fontWeight: 600,
    fontSize: "15px"
  },
  btnText: {
    fontWeight: 500,
    fontSize: "12px"
  },
  normalText: {
    fontWeight: 500,
    fontSize: "14px"
  },
  lightText: {
    fontWeight: 500,
    fontSize: "12px"
  },
  linkText: {
    color: colors.hyperlink,
    fontWeight: 500,
    fontSize: "12px",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    gap: "5px"
  },
  label: {
    color: colors.secondaryText,
    fontWeight: 500,
    fontSize: "12px"
  },
  error: {
    color: colors.errorColor,
    fontWeight: 500,
    fontSize: "10px"
  },
  warning: {
    color: colors.warningText,
    fontWeight: 700,
    fontSize: "12px",
    display: "inline-block"
  }
});
